import React, { createContext, useState } from "react";

const INITIAL_BREADCRUMB = { category: "", subcategory: "", segment: "" };

export const FilterContext = createContext({
  filter: [],
  setFilters: () => null,
  breadcrumb: INITIAL_BREADCRUMB,
  setBreadcrumb: () => null,
});

export function FilterProvider({ children }) {
  const [filter, setFilter] = useState([]);
  const [breadcrumb, setBreadcrumbState] = useState(INITIAL_BREADCRUMB);

  function setFilters(itensFiltro) {
    setFilter(itensFiltro);
  }

  function setBreadcrumb(names) {
    setBreadcrumbState((prev) => ({ ...prev, ...names }));
  }

  return (
    <FilterContext.Provider value={{ filter, setFilters, breadcrumb, setBreadcrumb }}>
      {children}
    </FilterContext.Provider>
  );
}
